/**
 * Режим просмотра: приложение открыто в обычном браузере, без Telegram.
 *
 * Человек может посмотреть тарифы и устройство сервиса до того, как
 * откроет бота. Всё, что требует аккаунта, — покупка, профиль,
 * рефералка — ведёт в Telegram: личность подтверждается только подписью
 * Telegram, и другого способа войти у приложения нет.
 *
 * Признак выставляется один раз при запуске (main.tsx) и не меняется.
 */
import { config } from '@/shared/config/env';

let guest = false;

export function setGuest(value: boolean): void {
  guest = value;
}

export function isGuest(): boolean {
  return guest;
}

/** Ссылка на бота: /start с меткой, чтобы видеть, сколько пришло с сайта. */
export const botStartUrl = `https://t.me/${config.botUsername}?start=web`;
